import React, { useState } from "react";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import './BottomSlidingPane.css'
import {KeyboardArrowDown} from '@material-ui/icons';
import { IconButton } from "@material-ui/core";

const BottomSlidingPane = (props) => { 

  return (
      <SlidingPane
        className="sliding-pane"
        isOpen={props.handleOpen}
        hideHeader={true}
        from="bottom"
        width="100%"
      >
        <div>
          <IconButton>
            <KeyboardArrowDown onClick={() => props.handleClose()} fontSize='large'/>
          </IconButton>
        </div>
      </SlidingPane>
  );
};

export default BottomSlidingPane